<template>
  <div id="app">
    <Watermark :content="watermarkText" :gap="[200, 200]" :z-index="9999"
      :font-style="{ color: 'rgba(0, 0, 0, 0.08)', fontSize: '14px' }">
      <router-view></router-view>
    </Watermark>
  </div>
</template>

<script>
import Watermark from './components/common/Watermark.vue';

export default {
  name: 'App',
  components: {
    Watermark,
  },
  computed: {
    // 登录后展示当前用户昵称作为水印，未登录时不显示
    watermarkText() {
      const query = this.$route.query
      const text = query?.name || this.userStore?.userInfo?.nickName || ''
      return text;
    },
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
